module.exports = __webpack_public_path__ + "img/schedule_create.affe7263.svg";